import { c as _c } from "react/compiler-runtime";
import React from "react";
import { BsGrid3X3GapFill } from "react-icons/bs";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { ImPhoneHangUp } from "react-icons/im";
import { Button } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
interface CallControlsProps {
  isMuted: boolean;
  onToggleMute: () => void;
  onHangup: () => void;
  showKeypad: boolean;
  onToggleKeypad: () => void;
  hangupDisabled?: boolean;
  onTransfer?: () => void;
  transferDisabled?: boolean;
  /** Optional control slot rendered before the hangup button (e.g. the AI
   * scribe "save visit as note" menu). */
  scribeMenu?: React.ReactNode;
}
const CallControls: React.FC<CallControlsProps> = t0 => {
  const $ = _c(27);
  const {
    isMuted,
    onToggleMute,
    onHangup,
    showKeypad,
    onToggleKeypad,
    hangupDisabled,
    onTransfer,
    transferDisabled,
    scribeMenu
  } = t0;
  const t1 = isMuted ? "destructive" : "primary";
  const t2 = !isMuted && "bg-status-success-bg text-status-success-text hover:bg-status-success-bg/80";
  let t3;
  if ($[0] !== t2) {
    t3 = cx("p-2", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isMuted) {
    t4 = isMuted ? <FaMicrophoneSlash /> : <FaMicrophone />;
    $[2] = isMuted;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onToggleMute || $[5] !== t1 || $[6] !== t3 || $[7] !== t4) {
    t5 = <Button variant={t1} onClick={onToggleMute} className={t3}>{t4}</Button>;
    $[4] = onToggleMute;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = showKeypad ? "primary" : "secondary";
  const t7 = showKeypad ? "Hide Keypad" : "Show Keypad";
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BsGrid3X3GapFill />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== onToggleKeypad || $[11] !== t6 || $[12] !== t7) {
    t9 = <Button variant={t6} onClick={onToggleKeypad} className="p-2" title={t7}>{t8}</Button>;
    $[10] = onToggleKeypad;
    $[11] = t6;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onTransfer || $[15] !== transferDisabled) {
    t10 = onTransfer && <Button variant="secondary" onClick={onTransfer} className="p-2" title="Transfer Call" disabled={transferDisabled}><FaArrowRightArrowLeft /></Button>;
    $[14] = onTransfer;
    $[15] = transferDisabled;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ImPhoneHangUp />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== hangupDisabled || $[19] !== onHangup) {
    t12 = <Button variant="destructive" onClick={onHangup} className="p-2" disabled={hangupDisabled}>{t11}</Button>;
    $[18] = hangupDisabled;
    $[19] = onHangup;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== scribeMenu || $[22] !== t10 || $[23] !== t12 || $[24] !== t5 || $[25] !== t9) {
    t13 = <div className="flex flex-row items-center gap-2">{t5}{t9}{t10}{scribeMenu}{t12}</div>;
    $[21] = scribeMenu;
    $[22] = t10;
    $[23] = t12;
    $[24] = t5;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
export default CallControls;